import React from "react";
import { render } from "react-dom";
import CartButton from "../widgets/cartbutton";
import NewCartButton from "../widgets/cartbutton/NewCartButton";
import PreorderButton from "../widgets/PreorderButton";

// Cart button
let cartButtonElem = document.querySelectorAll(".widget-cartbutton");
if (cartButtonElem.length) {
    cartButtonElem.forEach(elem => {
        render(<CartButton elem={elem} />, elem);
    });
}

let newCartButtonElem = document.querySelectorAll(".new-widget-cartbutton");
if (newCartButtonElem.length) {
    newCartButtonElem.forEach(elem => render(<NewCartButton elem={elem} />, elem));
}

// preorder / whislist button
let preorderButton = document.querySelectorAll(".new-widget-preorder-button");
if (preorderButton.length) {
    preorderButton.forEach(elem => render(<PreorderButton elem={elem} />, elem));
}
